"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.horizontalCollapseMotion = exports.collapseMotion = exports.skipOpacityTransition = exports.getCurrentWidth = exports.getRealWidth = exports.getCollapsedWidth = exports.getCurrentHeight = exports.getRealHeight = exports.getCollapsedHeight = void 0;
/* HEIGHT */
const getCollapsedHeight = () => ({ height: 0, opacity: 0 });
exports.getCollapsedHeight = getCollapsedHeight;
const getRealHeight = (node) => {
    const { scrollHeight } = node;
    return { height: scrollHeight, opacity: 1 };
};
exports.getRealHeight = getRealHeight;
const getCurrentHeight = (node) => ({ height: node ? node.offsetHeight : 0 });
exports.getCurrentHeight = getCurrentHeight;
/* WIDTH */
const getCollapsedWidth = () => ({ width: 0, opacity: 0 });
exports.getCollapsedWidth = getCollapsedWidth;
const getRealWidth = (node) => {
    const { scrollWidth } = node;
    return { width: scrollWidth, opacity: 1 };
};
exports.getRealWidth = getRealWidth;
const getCurrentWidth = (node) => ({ width: node ? node.offsetWidth : 0 });
exports.getCurrentWidth = getCurrentWidth;
/* OPACITY */
const skipOpacityTransition = (_, event) => (event === null || event === void 0 ? void 0 : event.deadline) === true || event.propertyName === "height";
exports.skipOpacityTransition = skipOpacityTransition;
/* MOTIONS */
exports.collapseMotion = {
    motionName: "ant-motion-collapse",
    onAppearStart: exports.getCollapsedHeight,
    onEnterStart: exports.getCollapsedHeight,
    onAppearActive: exports.getRealHeight,
    onEnterActive: exports.getRealHeight,
    onLeaveStart: exports.getCurrentHeight,
    onLeaveActive: exports.getCollapsedHeight,
    onAppearEnd: exports.skipOpacityTransition,
    onEnterEnd: exports.skipOpacityTransition,
    onLeaveEnd: exports.skipOpacityTransition,
    motionDeadline: 500,
    motionAppear: false,
    leavedClassName: "ant-motion-collapse-leaved",
};
exports.horizontalCollapseMotion = {
    motionName: "gerudo-motion-collapse-width",
    onAppearStart: exports.getCollapsedWidth,
    onEnterStart: exports.getCollapsedWidth,
    onAppearActive: exports.getRealWidth,
    onEnterActive: exports.getRealWidth,
    onLeaveStart: exports.getCurrentWidth,
    onLeaveActive: exports.getCollapsedWidth,
    onAppearEnd: exports.skipOpacityTransition,
    onEnterEnd: exports.skipOpacityTransition,
    onLeaveEnd: exports.skipOpacityTransition,
    motionDeadline: 500,
    motionAppear: false,
    removeOnLeave: false,
    leavedClassName: "gerudo-motion-collapse-leaved",
};
//# sourceMappingURL=collapseMotion.js.map